import React from "react";
import { Button, Tooltip } from "@flixbus/honeycomb-react";
import { Icon, IconDelete } from "@flixbus/honeycomb-icons-react";
import styles from "./RemoveCategoryButton.module.scss";

interface RemoveCategoryButtonProps {
  index: number;
  onRemove: (index: number) => void;
}

const RemoveCategoryButton: React.FC<RemoveCategoryButtonProps> = ({
  index,
  onRemove,
}) => {
  const buttonRef = React.useRef<HTMLAnchorElement>(null);
  const [tooltipActive, setTooltipActive] = React.useState(false);
  const tooltipId = `remove-category-${index}`;

  return (
    <Tooltip
      id={tooltipId}
      content="Remove this category and clear its selected subcategories"
      active={tooltipActive}
      disableInternalHandlers
      fixed
      targetRef={buttonRef}
      position="left"
      extraClasses={styles.removeTooltip}
    >
      <Button
        ref={buttonRef}
        display="square"
        appearance="link"
        aria-label={`Remove category ${index + 1}`}
        aria-describedby={tooltipId}
        extraClasses={styles.removeButton}
        onClick={() => onRemove(index)}
        onMouseEnter={() => setTooltipActive(true)}
        onMouseLeave={() => setTooltipActive(false)}
        onFocus={() => setTooltipActive(true)}
        onBlur={() => setTooltipActive(false)}
      >
        <Icon InlineIcon={IconDelete} aria-hidden="true" />
      </Button>
    </Tooltip>
  );
};

export default RemoveCategoryButton;
